<div class="finances-container">

    <div class="header">
        <div class="left">
            <h2 mat-title>{{ config.title }}</h2>
        </div>
        <app-month-picker></app-month-picker>
        <div class="right">
            <button *ngIf="config.copyPrevious" mat-stroked-button (click)="copyPrevious()" title="Traz os lançamentos do mês anterior que ainda não existem neste mês">
                <mat-icon>content_copy</mat-icon> Copy previous month
            </button>
            <button mat-icon-button (click)="edit()">
                <mat-icon class="material-symbols-outlined">{{icons.add}}</mat-icon>
            </button>
        </div>
    </div>

    <div *ngIf="isLoading">Carregando...</div>

    <div class="table-wrapper">
        <table mat-table [dataSource]="rows">
            <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef>Description</th>
                <td mat-cell *matCellDef="let e">{{ e.description }}</td>
            </ng-container>
            <ng-container matColumnDef="category">
                <th mat-header-cell *matHeaderCellDef>Category</th>
                <td mat-cell *matCellDef="let e">{{ e.category }}</td>
            </ng-container>
            <ng-container matColumnDef="value">
                <th mat-header-cell *matHeaderCellDef class="value">Value</th>
                <td mat-cell *matCellDef="let e" class="value">R$ {{ e.value | number:'1.2-2' }}</td>
            </ng-container>
            <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let e">
                    @if (e.computed) {
                        <!-- Comes from Investments or from the credit card statements -->
                        <mat-icon class="computed-icon" title="Calculado automaticamente">calculate</mat-icon>
                    } @else {
                        <button mat-icon-button (click)="edit(e)"><mat-icon color="primary" class="material-symbols-outlined">{{icons.edit}}</mat-icon></button>
                        <button mat-icon-button (click)="delete(e)"><mat-icon color="primary" class="material-symbols-outlined">{{icons.delete}}</mat-icon></button>
                    }
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="columns"></tr>
            <tr mat-row *matRowDef="let row; columns: columns;" [class.computed]="row.computed"></tr>
        </table>
    </div>

    <p class="empty" *ngIf="!isLoading && !entries.length && !computed.length">No entries in this month.</p>
    <div class="total">Total: R$ {{ total | number:'1.2-2' }}</div>
</div>
